module.exports = __webpack_public_path__ + "static/media/barter-preppers.470e4bc4.jpg";